import { render, staticRenderFns } from "./PrApplyForm.vue?vue&type=template&id=4747deba&scoped=true&"
import script from "./PrApplyForm.vue?vue&type=script&lang=js&"
export * from "./PrApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./PrApplyForm.vue?vue&type=style&index=0&id=4747deba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747deba",
  null
  
)

export default component.exports